export const homeMigration = {
  1: previousVersionState => ({
    local: previousVersionState.local
  })
};
